#import "@core/schema/fragments/PublicOrderFull.graphql"

mutation (
  $input: OrderInput!
) {
  createOrder(
    input: $input
  ) {
    ...PublicOrderFull
  }
}
